import React from "react";

export const INPUT_CSS =
  "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white ";

const StyledInput = (props) => {
  return <input {...props} className={INPUT_CSS + props.className} />;
};

export default StyledInput;
